// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_DEVICE_ELIGIBILITY_DATA = 'GET_DEVICE_ELIGIBILITY_DATA';
export const GET_DEVICE_ELIGIBILITY_DATA_SUCCESS = 'GET_DEVICE_ELIGIBILITY_DATA_SUCCESS';
export const GET_DEVICE_ELIGIBILITY_DATA_FAIL = 'GET_DEVICE_ELIGIBILITY_DATA_FAIL';

export const {
    getDeviceEligibilityData,
    getDeviceEligibilityDataSuccess,
    getDeviceEligibilityDataFail,
} = createActions(
    GET_DEVICE_ELIGIBILITY_DATA,
    GET_DEVICE_ELIGIBILITY_DATA_SUCCESS,
    GET_DEVICE_ELIGIBILITY_DATA_FAIL
);